const Section = ({ title, seeText, className = "mb-2", onClick }) => {
  return (
    <div className={`d-flex justify-content-between ${className}`}>
      <div className="text-lg font-bold">{title}</div>
      <div className="text-base font-bold text-gray-500" onClick={onClick}>
        {seeText}
      </div>
    </div>
  );
};

export default Section;
